import { render, staticRenderFns } from "./first-step.vue?vue&type=template&id=47861696&"
import script from "./first-step.vue?vue&type=script&lang=js&"
export * from "./first-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports